import { useAppContext } from "../../context/Context";
import { ACTION } from "../../context/actionTypes";
import { setBottomBarError } from "../../utils/Functions";
import api from "../../utils/api";

export default function useDeleteSalesRep(props) {
    const [_, dispatch] = useAppContext();
    const { id, reload } = props;

    const deleteSalesRep = async () => {
        try {
            await api.delete(`/salesrep/${id}`);
            await reload();
            toggleMe();
        } catch (err) {
            console.error("Failed to delete salesrep", err);
            setBottomBarError(dispatch, err);
        }
    };

    const toggleMe = () => dispatch({ type: ACTION.SET_GENERIC_MODAL, payload: null });

    return [{}, { deleteSalesRep, toggleMe }];
}
